var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "scheduler-node-page" },
    [
      _c(
        "el-card",
        { staticClass: "filter-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            { attrs: { inline: true, size: "small", model: _vm.query } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "节点IP" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入节点IP",
                      clearable: "",
                      "prefix-icon": "el-icon-position",
                    },
                    model: {
                      value: _vm.query.ip,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "ip", $$v)
                      },
                      expression: "query.ip",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "应用名称" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "例如 crmeb-admin",
                      clearable: "",
                      "prefix-icon": "el-icon-menu",
                    },
                    model: {
                      value: _vm.query.applicationName,
                      callback: function ($$v) {
                        _vm.$set(_vm.query, "applicationName", $$v)
                      },
                      expression: "query.applicationName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "160px" },
                      attrs: { placeholder: "全部", clearable: "" },
                      model: {
                        value: _vm.query.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status",
                      },
                    },
                    _vm._l(_vm.statusOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh-left" },
                      on: { click: _vm.handleReset },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "summary-card", attrs: { shadow: "never" } },
        [
          _c("div", { staticClass: "summary-items" }, [
            _c("div", { staticClass: "summary-item" }, [
              _c("p", { staticClass: "label" }, [_vm._v("节点总数")]),
              _vm._v(" "),
              _c("p", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.statusSummary.total)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "summary-item" }, [
              _c("p", { staticClass: "label with-dot online" }, [
                _vm._v("在线"),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.statusSummary.online)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "summary-item" }, [
              _c("p", { staticClass: "label with-dot offline" }, [
                _vm._v("离线"),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.statusSummary.offline)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "summary-item" }, [
              _c("p", { staticClass: "label with-dot blocked" }, [
                _vm._v("已剔除"),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "value" }, [
                _vm._v(_vm._s(_vm.statusSummary.blocked)),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "table-card", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            {
              staticClass: "table-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("div", [
                _c("span", { staticClass: "table-title" }, [
                  _vm._v("调度节点列表"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "table-subtitle" }, [
                  _vm._v("共 " + _vm._s(_vm.total) + " 条"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "table-header-meta" },
                [
                  _c("span", { staticClass: "refresh-text" }, [
                    _vm._v(
                      "最近刷新：" +
                        _vm._s(_vm.formatDate(_vm.lastRefreshAt) || "--")
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "mini",
                        icon: "el-icon-refresh",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.getList },
                    },
                    [_vm._v("刷新")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.tableData,
                border: "",
                "row-class-name": _vm.getRowClassName,
                "empty-text": "暂无节点数据，点击右上角刷新试试~",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "applicationName",
                  label: "应用名称",
                  "min-width": "160",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "ip", label: "节点IP", "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          { attrs: { size: "mini", effect: "plain" } },
                          [_vm._v(_vm._s(scope.row.ip))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "hostname",
                  label: "主机名",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "weight", label: "权重", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input-number", {
                          attrs: {
                            min: 1,
                            max: 100,
                            size: "mini",
                            "controls-position": "right",
                          },
                          on: {
                            change: function (value) {
                              return _vm.handleWeightChange(scope.row, value)
                            },
                          },
                          model: {
                            value: scope.row.editableWeight,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "editableWeight", $$v)
                            },
                            expression: "scope.row.editableWeight",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "状态", "min-width": "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                (_vm.statusMap[scope.row.status] &&
                                  _vm.statusMap[scope.row.status].tag) ||
                                "info",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  (_vm.statusMap[scope.row.status] &&
                                    _vm.statusMap[scope.row.status].label) ||
                                    "未知"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "lastHeartbeatTime",
                  label: "最近心跳",
                  "min-width": "190",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatDate(scope.row.lastHeartbeatTime)
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "updateTime",
                  label: "更新时间",
                  "min-width": "190",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatDate(scope.row.updateTime)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "260", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "action-group" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "text",
                                  size: "mini",
                                  disabled: scope.row.status === 1,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEnable(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              允许调度\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "text",
                                  size: "mini",
                                  disabled: scope.row.status === 3,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleBlock(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              剔除节点\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticClass: "danger-text",
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              删除记录\n            ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, prev, pager, next, sizes",
                  total: _vm.total,
                  "current-page": _vm.page,
                  "page-size": _vm.limit,
                },
                on: {
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }